<template>

  <div class="catalog">
    <div class="catalog__group" v-for="(category, index) in categories" :key="index">

      <div class="catalog__category">
        <md-menu md-size="small">
          <md-button md-menu-trigger>
            <md-icon>more_vert</md-icon>
          </md-button>

          <md-menu-content>
            <md-menu-item @click="changeStateofCategory(category.id, false)">Alle deaktivieren</md-menu-item>
            <md-menu-item @click="changeStateofCategory(category.id, true)">Alle aktivieren</md-menu-item>
          </md-menu-content>
        </md-menu>

        <h2 class="md-title catalog__subtitle">{{category.name}} </h2>
      </div>

      <div class="catalog__items">
        <div class="catalog__item" v-for="item in categories[index].items" :key="item.id">
          <catalog-item :item="item"></catalog-item>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import CatalogItem from './CatalogItem'
  export default {
    name: "Catalog",
    components: {
      CatalogItem
    },
    data() {
      return {
        active: true
      }
    },
    computed: {
      ...mapGetters('auth', [
        'user'
      ]),
      ...mapGetters('catalog', [
        'categories'
      ]),
    },
    mounted() {
      this.loadItems(this.user.locationId);
    },
    methods: {
      ...mapActions('catalog', [
        'loadItems',
        'updateCategoryItems'
      ]),
      changeStateofCategory(id, state) {
        this.updateCategoryItems({id: id, state: state})
      }
    }
  }
</script>